<template>
  <div class="px-small">
    <div class="flex flex--center flex--justify-end">
      <span class="text-center"> - </span>
      <ak-tooltip theme="light" placement="right" :max-width="300">
        <template #trigger>
          <i class="icon icon-information-circled color-grey-light ml-tiny" />
        </template>
        This statistic is unavailable for this email template as it was sent
        prior to necessary data being collected.
      </ak-tooltip>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AkEmailListPopover',
})
</script>
